// Copyright (c) 2018 Deere & Company

import actions from '../../action-list';

export const updateIsActionButtonDisabled = isDisabled =>

    dispatch => {

        dispatch({
            isDisabled,
            type: actions.UPDATE_CLAIM_NORMAL_IS_ACTION_BUTTON_DISABLED
        });

    };



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/is-action-button-disabled.js